import { type EnumLike, z } from 'zod';

export function isTruthy<T>(value: T | null | undefined | false): value is T {
  return Boolean(value);
}

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function optionalEnum<T extends EnumLike>(
  nativeEnum: T,
  defaultValue: T[keyof T]
): z.ZodEffects<
  z.ZodDefault<z.ZodOptional<z.ZodNativeEnum<T>>>,
  T[keyof T] | undefined,
  T[keyof T] | undefined
> {
  return z
    .nativeEnum(nativeEnum)
    .optional()
    .default(defaultValue)
    .transform((arg) => arg ?? defaultValue);
}
